module.exports = __webpack_public_path__ + "static/img/four_01.c2c5867.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/AtomicChain/assets/personalIntroduction/four_01.png
// module id = mIwz
// module chunks = 3